import { useStore } from "../lib/store";
import { iconButtonClass } from "./ThemeToggle";

/** Turns reading cards and announcements aloud on or off. Silent anyway while sound is off. */
export function VoiceToggle() {
  const voiceOn = useStore((s) => s.voiceOn);
  const soundOn = useStore((s) => s.soundOn);
  const setVoice = useStore((s) => s.setVoice);
  const label = !soundOn ? "Vorlesen (Ton ist aus)" : voiceOn ? "Vorlesen ausschalten" : "Vorlesen einschalten";
  return (
    <button
      type="button"
      className={`${iconButtonClass} ${soundOn ? "" : "opacity-50"}`}
      aria-label={label}
      aria-pressed={voiceOn}
      title={label}
      onClick={() => setVoice(!voiceOn)}
    >
      <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M4 5.5h16v10H11l-4.5 3.5v-3.5H4z" />
        {voiceOn ? <path d="M8 9.5h8M8 12h5" /> : <path d="m9.5 8.5 5 5m0-5-5 5" />}
      </svg>
    </button>
  );
}
